import { Column } from '../../column';
import { DocumentType } from '../document-type';
import { communicationsColumns } from './communications-columns';
import { contractColumns } from './contract-columns';
import { dispositionColumns } from './disposition-columns';
import { expiredDocumentsColumns } from './expired-documents-columns';
import { offeringDocumentsColumns } from './offering-columns';
import { DocumentsTableType } from './table-type';

export const retrieveColumnsForDocuments = (
  documentType: DocumentType
): Column<any>[] => {
  switch (documentType) {
    case 'Disposition':
      return dispositionColumns;
    case 'ExpiredDocuments':
      return expiredDocumentsColumns;
    case 'Contract':
    default:
      return contractColumns;
  }
};

export const retrieveColumnsForDocumentsArea = (
  tableType: DocumentsTableType
): Column<any>[] => {
  switch (tableType.section) {
    case 'DOCUMENTS':
      return retrieveColumnsForDocuments(tableType.documentsType);
    case 'INFO_OFFER':
      return offeringDocumentsColumns;
    case 'COMMUNICATIONS':
      return communicationsColumns;
  }
};
